module.exports = __webpack_public_path__ + "img/Middle-Semi-Elliptical-Attachment-L-26.7d22f022.png";